/**
 * Shared styles for AIMe components
 */

// Common colors used across AIMe components
export const colors = {
  // Status colors
  enabled: {
    background: '#98DDDB',
    text: '#133A39',
    button: '#008077',
    buttonHover: '#006c64',
  },
  locked: {
    background: '#FFD5E2',
    text: '#770022',
    button: '#770022',
    buttonHover: '#5a001a',
  },
  loading: {
    background: '#E0E0E0',
    text: '#666666',
  },

  // Notification types (reused from NotificationBox)
  warning: {
    background: '#FFFAEC',
    border: '#856800',
    text: '#856800',
    button: '#856800',
    buttonHover: '#6b5400',
  },
  error: {
    background: '#FFD5E2',
    border: '#770022',
    text: '#770022',
    button: '#770022',
    buttonHover: '#5a001a',
  },
};

// Common styles for toggle buttons
export const toggleButtonStyles = {
  enabled: (isActive) => ({
    bgcolor: isActive ? `${colors.enabled.button} !important` : 'inherit',
    color: isActive ? '#FFFFFF !important' : 'inherit',
    padding: '8px 24px',
    borderTopLeftRadius: '6px !important',
    borderBottomLeftRadius: '6px !important',
  }),
  locked: (isActive) => ({
    bgcolor: isActive ? `${colors.locked.background} !important` : 'inherit',
    color: isActive ? `${colors.locked.text} !important` : 'inherit',
    padding: '8px 24px',
    borderTopRightRadius: '6px !important',
    borderBottomRightRadius: '6px !important',
  }),
};

// Common styles for status chips
export const chipStyles = {
  getStatusChipStyle: (isEnabled, isLoading) => ({
    backgroundColor: isLoading 
      ? colors.loading.background 
      : (isEnabled ? colors.enabled.background : colors.locked.background),
    color: isLoading 
      ? colors.loading.text 
      : (isEnabled ? colors.enabled.text : colors.locked.text),
    borderWidth: '0px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '4px 12px',
  }),
};
